window.custom_toggle = function(){
    var $tog = jQuery.noConflict();

    $tog(".comp-sec-btm").toggleClass("fade-block");

    $tog(".start").click(function() {
        $tog(this).css('visibility', 'hidden');
        $tog(this).toggleClass('grey');
        $tog(this).text($tog(this).text() == 'Start' ? "Pause" : "Start");
        $tog(".comp-sec-btm").toggleClass("fade-block");
        if ($tog("#stopwatch").html() == "00:00") {
            $tog("#que1").addClass("lsat-question-selected");
        }
    });

    /******** show hide **********/
    $tog(".to-do-toggle").click(function() {
        $tog(".stopwatch").slideToggle("fast");
        $tog(".quiz-number").slideToggle("fast");
        $tog(".game-info").slideToggle("fast");
        $tog(".pdf").slideToggle("fast");
        $tog(".to-do-toggle i").toggle();
    });
    /********* show hide **********/

    $tog("#submit").click(function() {
        //stopwatch
        var stopwatch = $tog("#stopwatch").html();
        $tog("#timervalue").val(stopwatch);
    });
    $tog(".rest-game-ans").mouseover(function() {
        $tog(".ans-selection").removeClass("active");
        $tog(".ans-selection" + $tog(this).attr('datavalue')).addClass("active");
    });
    $tog(".ans-selection").click(function() {
        $tog(".ans-selection").removeClass("active");
        $tog(this).addClass("active");
    });
}